import type { PatientProfileFormData } from '@/features/patient/patient-profile-form'
import type { InsVerificationPatientData } from '@/features/patient/patient-profile-form/model/useRunInsVerification'

export type ExternalIdentityInput = {
  insNIR: string
  insOID: string
  birthSurname: string
  birthName: string
  birthDate: string
  gender: NonNullable<PatientProfileFormData['gender']>
  birthPlaceCode: string
}

export type ExternalIdentityPatientData = InsVerificationPatientData & Pick<PatientProfileFormData, 'birthName' | 'name'>

export function buildExternalIdentityData(input: ExternalIdentityInput) {
  const insNIR = input.insNIR.replace(/\s/g, '').toUpperCase()
  const birthSurname = input.birthSurname.trim().toUpperCase()
  const birthName = input.birthName.trim().toUpperCase()
  // The first birth given name (INSi `s_given`) is the first name of the birth given-names list.
  const birthFirstName = birthName.split(/\s+/)[0] ?? ''
  const birthPlaceCode = input.birthPlaceCode.trim().toUpperCase()

  const patientData: ExternalIdentityPatientData = {
    insNIR,
    insOID: input.insOID,
    birthSurname,
    surname: birthSurname,
    birthName,
    birthFirstName,
    name: birthFirstName,
    birthday: new Date(`${input.birthDate}T00:00:00`),
    gender: input.gender,
    birthPlaceCode,
  }

  return {
    patientData,
    ingestTraits: {
      birthName: birthSurname,
      firstName: birthName,
      birthFirstName,
      birthDate: input.birthDate,
      sex: input.gender,
      birthPlaceCode,
    },
  }
}
